import type { BenchmarkGranularity } from "../../../types/common";

export enum ActivationSubscriptions {
    BenchmarkDigest = "BenchmarkDigest",
    CompetitorsAlerts = "CompetitorsAlerts",
    NewsAlerts = "NewsAlerts",
}

export const subscriptionsTrackingNames = {
    [ActivationSubscriptions.BenchmarkDigest]: "benchmark",
    [ActivationSubscriptions.CompetitorsAlerts]: "alerts",
    [ActivationSubscriptions.NewsAlerts]: "newsAlerts",
} as const;

export type SubscriptionTrackingName = (typeof subscriptionsTrackingNames)[keyof typeof subscriptionsTrackingNames];

export type NewsAlertsSubscriptionStatusSchema = {
    isSubscribed: boolean;
    granularity: BenchmarkGranularity;
};
